import React, { useEffect, useState, useMemo, useCallback } from 'react';
import Loading from 'react-loading';
import { Card, CardBody, CardTitle } from 'reactstrap';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  TimeScale,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';
import * as faker from '@faker-js/faker';
import { Bar, Line, Pie } from 'react-chartjs-2';
import { api } from '../../services/api';
import { CardContainer, Container } from './Card.styled';
import { FilterYear } from '../components/filterYear';
import { useEvent } from '../../hooks/useEvent';
import { toast } from 'react-toastify';
import {
  MdGroups,
  MdOutlineConfirmationNumber,
  MdOutlineAssignmentTurnedIn,
  MdOutlineCampaign,
  MdOutlineRateReview,
} from 'react-icons/md';

import { InfoCard } from './InfoCard';
import EvaluationCard from './EvaluationCard';
import { CardTotal } from './CardTotal';
import { FaUsers } from 'react-icons/fa';
import { ExpofeiraChart } from './ExpofeiraChart';
import { FavoritosChart } from './FavoritosChart';
import { LojasChart } from './LojasChart';
import GraficoEventosFavoritos from './Grafico';
import CommentsModal from './CommentsModal';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  PointElement,
  LineElement,
  ArcElement,
  Filler,
);

export function Dashboard(): React.JSX.Element {
  const [loading, setLoading] = useState(false);
  const { setCurrentYear, currentYear } = useEvent();
  const [ratingExpofeira, setRatingExpofeira] = useState([]);
  const [ratingExpofeiraMean, setRatingExpofeiraMean] = useState(0);
  const [rating, setRating] = useState([]);
  const [ratingMean, setRatingMean] = useState(0);
  const [usersRegistered, setUsersRegistered] = useState(0);
  const [ratingAll, setRatingAll] = useState(0);
  const [ticketsAll, setTicketsAll] = useState(0);
  const [contactUs, setContactUs] = useState(0);
  const [complaining, setComplaining] = useState(0);
  const [eventAll, setEventAll] = useState([]);
  const [userAll, setUserAll] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>(null);
  // useEffect(() => {
  //   getAllData()
  //     .then(() => {})
  //     .catch(() => {});
  // }, [currentYear]);

  // async function getAllData(): Promise<void> {
  //   try {
  //     const response = await api.get('dashboard', {
  //       params: {
  //         year: currentYear,
  //       },
  //     });
  //     setRatingExpofeira(response.data.expofeira);
  //     setRatingExpofeiraMean(response.data.expofeiraMean);
  //     setRating(response.data.rating);
  //     setRatingMean(response.data.ratingMean);
  //     setUsersRegistered(response.data.registeredUsersCount);
  //     setRatingAll(response.data.ratingCount);
  //     setTicketsAll(response.data.ticketCount);
  //     setComplaining(response.data.complainingCount);
  //     setContactUs(response.data.contactUsCount);
  //     setEventAll(response.data.schedulesOrdered);
  //     setUserAll(response.data.allUsers);
  //   } catch (error: any) {
  //     if (error.response?.status === 401) {
  //       localStorage.removeItem('@expo:token');
  //       localStorage.removeItem('@expo:user');
  //       toast.error('Sessão expirada. Faça login novamente.');
  //       window.location.reload();
  //     } else {
  //       console.log(error);
  //       toast.error('Erro ao carregar dados do dashboard.');
  //     }
  //   }
  // }

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await api.get('/dashboard/dashboard-web');
        setDashboardData(data);
      } catch (error) {
        console.error('Erro ao buscar dashboard:', error);
      } finally {
        setLoading(false);
      }
    };

    void fetchData();
  }, []);

  const labels = ['Atrações', 'Organização', 'Produtos', 'Segurança', 'Transporte'];
  const labelsEvent = ['Ótimo', 'Bom', 'Regular', 'Ruim', 'Péssimo'];
  const data = {
    labels,
    datasets: [
      {
        label: 'Avaliação',
        data: ratingExpofeira?.map((item) => item),
        // borderColor: 'rgb(255, 99, 132)',
        backgroundColor: '#2D9CDB',
        borderRadius: 5,
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    elements: {
      bar: {
        borderWidth: 0,
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        display: false,
        grid: {
          display: false,
        },
        max: 5,
      },
      y: {
        stacked: true,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
  };

  const dataEvent = {
    labels: labelsEvent,
    datasets: [
      {
        label: 'Avaliação',
        data: rating?.map((item) => item),
        // borderColor: 'rgb(255, 99, 132)',
        backgroundColor: '#2D9CDB',
        borderRadius: 5,
      },
    ],
  };

  const DATA_COUNT = 7;
  const NUMBER_CFG = { count: DATA_COUNT, min: 0, max: 100 };

  const datas = {
    labels: [
      // Date Objects
      new Date(),
    ],
    datasets: [
      {
        label: 'My First dataset',
        backgroundColor: 'red',
        // borderColor: Utils.CHART_COLORS.red,
        fill: false,
        data: NUMBER_CFG,
        showLine: true,
      },
    ],
  };
  // const config = {
  //   type: 'line',
  //   data,
  //   options: {
  //     plugins: {
  //       title: {
  //         text: 'Chart.js Time Scale',
  //         display: true,
  //       },
  //     },
  //     scales: {
  //       x: {
  //         type: 'time',
  //         time: {
  //           // Luxon format string
  //           tooltipFormat: 'DD T',
  //         },
  //         title: {
  //           display: true,
  //           text: 'Date',
  //         },
  //       },
  //       y: {
  //         title: {
  //           display: true,
  //           text: 'value',
  //         },
  //       },
  //     },
  //   },
  // };
  const optionsLine = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        stacked: true,
        display: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      filler: {
        propagate: true,
      },
      legend: {
        position: 'top' as const,
      },
      title: {
        display: false,
        text: 'Chart.js Line Chart',
      },
    },
  };

  const dataLine = {
    labels: userAll?.map((item) => item.date),
    datasets: [
      {
        label: 'Usuários',
        data: userAll?.map((item) => item.total),
        fill: true,
        tension: 0.3,
        borderColor: '#FF847C',
        backgroundColor: '#FF847C',
        segment: {
          backgroundColor: '#FFE6E5',
          borderColor: '#FF847C',
        },
      },
    ],
  };

  const dataPie = {
    labels: eventAll?.map((item) => item.name),
    datasets: [
      {
        label: 'Quantidade',
        data: eventAll?.map((item) => item.total),
        backgroundColor: ['#F94144', '#8FD0D4', '#F9C74F', '#90BE6D', '#2D9CDB', '#F3722C'],
        borderColor: ['#F94144', '#8FD0D4', '#F9C74F', '#90BE6D', '#2D9CDB', '#F3722C'],
        borderWidth: 1,
      },
    ],
  };
  const optionsPie = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'right' as const,
      },
      title: {
        display: false,
        text: 'Chart.js Line Chart',
      },
    },
  };
  return (
    <div style={{ display: 'flex', minHeight: '90vh', flex: 1 }}>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 25,
            flex: 1,
          }}
        >
          <Loading width={30} color={'#005675'} type={'spin'} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ebf0f3',
            minHeight: '90vh',
            padding: 20,
            flex: 1,
            flexWrap: 'wrap',
          }}
        >
          <div style={{ marginBottom: 20 }}>
            <span style={{ fontSize: 20, fontWeight: 600, color: '#2A2C85' }}>Dahsboard</span>
          </div>
          <div
            style={{
              display: 'flex',
              gap: 20,
              marginBottom: 20,
              flexDirection: 'column',
              flexWrap: 'wrap',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                gap: 20,
                marginBottom: 20,
                flexWrap: 'wrap',
              }}
            >
              <ExpofeiraChart style={{ width: '40%' }} data={dashboardData?.expofeira} />
              <LojasChart style={{ width: '40%' }} data={dashboardData} />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 20,
                  justifyContent: 'space-around',
                  width: '15%',
                }}
              >
                <CardTotal
                  icon={<MdOutlineAssignmentTurnedIn size={16} />}
                  title="Avaliações totais"
                  total={dashboardData?.total_avaliacoes}
                />{' '}
                <CardTotal
                  icon={<MdOutlineCampaign size={16} />}
                  title="Fale conosco"
                  total={dashboardData?.fale_conosco}
                />{' '}
                <CardTotal
                  setModalOpen={setModalOpen}
                  icon={<MdOutlineRateReview size={16} />}
                  title="Comentários"
                  total={dashboardData?.comentarios?.total}
                  isModal={true}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                gap: 50,
                flexWrap: 'wrap',
                marginBottom: 20,
              }}
            >
              <EvaluationCard
                style={{ flex: 1 }}
                percentage1={dashboardData?.avaliacao_eventos?.porcentagens?.positivas}
                percentage2={dashboardData?.avaliacao_eventos?.porcentagens?.neutras}
                percentage3={dashboardData?.avaliacao_eventos?.porcentagens?.negativas}
                total={dashboardData?.avaliacao_eventos?.total}
              />

              <GraficoEventosFavoritos
                style={{ width: '40%' }}
                eventosFavoritos={dashboardData?.eventos_favoritos}
              />
              <FavoritosChart style={{ width: '40%' }} data={dashboardData} />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              justifyContent: 'space-between',
              width: '97%',
            }}
          >
            <InfoCard
              icon={<MdGroups size={20} />}
              title="Usuários"
              label1="Total"
              value1={dashboardData?.stats?.usuarios?.total}
              label2="Ativos"
              value2={dashboardData?.stats?.usuarios?.ativos}
              label3="Excluídos"
              value3={dashboardData?.stats?.usuarios?.excluidos}
            />
            <InfoCard
              icon={<MdGroups size={20} />}
              title="Lojas"
              label1="Cadastradas"
              value1={dashboardData?.stats?.lojas?.lojas_cadastradas}
              label2="Produtos Cadastrados"
              value2={dashboardData?.stats?.lojas?.produtos_cadastrados}
              label3="Produtos Salvos"
              value3={dashboardData?.stats?.lojas?.produtos_salvos}
            />
            <InfoCard
              icon={<MdOutlineConfirmationNumber size={20} />}
              title="Cupons"
              label1="Gerados"
              value1={dashboardData?.stats?.cupons?.gerados}
              label2="Resgatados"
              value2={dashboardData?.stats?.cupons?.resgatados}
              label3="Inativos"
              value3={dashboardData?.stats?.cupons?.inativos}
            />
            <InfoCard
              icon={<MdOutlineConfirmationNumber size={20} />}
              title="Sorteios"
              label1="Cadastrados"
              value1={dashboardData?.stats?.sorteios?.cadastrados}
              label2="Finalizados"
              value2={dashboardData?.stats?.sorteios?.finalizados}
              label3="Participantes"
              value3={dashboardData?.stats?.sorteios?.participantes}
            />
          </div>
          <CommentsModal
            comments={dashboardData?.comentarios?.lista}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
          />
        </div>
        // <div
        //   style={{
        //     display: 'flex',
        //     flexDirection: 'column',
        //     backgroundColor: '#ebf0f3',
        //     minHeight: '90vh',
        //   }}
        // >
        //   <Container
        //     className="col-sm-12"
        //     style={{
        //       display: 'flex',
        //       // flexDirection: 'row',

        //       justifyContent: 'center',
        //     }}
        //   >
        //     <div
        //       className="col-sm-4"
        //       style={{
        //         display: 'flex',
        //         flexDirection: 'row',
        //         justifyContent: 'space-between',
        //         marginLeft: 10,
        //         marginTop: 5,
        //       }}
        //     >
        //       <CardContainer
        //         style={{
        //           paddingLeft: 10,
        //           paddingRight: 10,
        //           paddingTop: 5,
        //           width: '49%',
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           height: 100,
        //         }}
        //       >
        //         <CardTitle
        //           className="title"
        //           title="Usuários Cadastrados"
        //           style={{ color: '#828282' }}
        //         >
        //           Usuários Cadastrados
        //         </CardTitle>
        //         {/* <CardBody> */}
        //         <b style={{ color: '#272859', fontSize: 34 }}>{usersRegistered}</b>
        //         {/* </CardBody> */}
        //       </CardContainer>

        //       <CardContainer
        //         style={{
        //           paddingLeft: 10,
        //           paddingRight: 10,
        //           paddingTop: 5,
        //           width: '49%',
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           height: 100,
        //         }}
        //       >
        //         <CardTitle
        //           className="title"
        //           title="Avaliações Realizadas"
        //           style={{ color: '#828282' }}
        //         >
        //           Avaliações Realizadas
        //         </CardTitle>
        //         {/* <CardBody> */}
        //         <b style={{ color: '#272859', fontSize: 34 }}>{ratingAll}</b>
        //         {/* </CardBody> */}
        //       </CardContainer>
        //     </div>
        //     <div
        //       className="col-sm-7"
        //       style={{
        //         display: 'flex',
        //         flexDirection: 'row',
        //         justifyContent: 'space-between',
        //         marginLeft: 10,
        //         marginBottom: 5,
        //         marginTop: 5,
        //       }}
        //     >
        //       <CardContainer
        //         style={{
        //           paddingLeft: 10,
        //           paddingRight: 10,
        //           paddingTop: 5,
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           height: 100,
        //           width: '33%',
        //         }}
        //       >
        //         <CardTitle
        //           className="title"
        //           title="Cupons Cadastrados"
        //           style={{ color: '#828282' }}
        //         >
        //           Cupons Cadastrados
        //         </CardTitle>
        //         {/* <CardBody> */}
        //         <b style={{ color: '#272859', fontSize: 34 }}>{ticketsAll}</b>
        //         {/* </CardBody> */}
        //       </CardContainer>

        //       <CardContainer
        //         style={{
        //           paddingLeft: 10,
        //           paddingRight: 10,
        //           paddingTop: 5,
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           height: 100,
        //           width: '33%',
        //         }}
        //       >
        //         <CardTitle className="title" style={{ color: '#828282' }}>
        //           Fale Conosco
        //         </CardTitle>
        //         {/* <CardBody> */}
        //         <b style={{ color: '#272859', fontSize: 34 }}>{contactUs}</b>
        //         {/* </CardBody> */}
        //       </CardContainer>

        //       <CardContainer
        //         style={{
        //           paddingLeft: 10,
        //           paddingRight: 10,
        //           paddingTop: 5,
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           height: 100,
        //           width: '33%',
        //         }}
        //       >
        //         <CardTitle className="title" style={{ color: '#828282' }}>
        //           Reclamações
        //         </CardTitle>
        //         {/* <CardBody> */}
        //         <b style={{ color: '#272859', fontSize: 34 }}>{complaining}</b>
        //         {/* </CardBody> */}
        //       </CardContainer>
        //     </div>
        //   </Container>
        //   <Container
        //     style={{
        //       display: 'flex',
        //       justifyContent: 'center',
        //     }}
        //   >
        //     <div
        //       className="col-sm-4"
        //       style={{
        //         display: 'flex',
        //         flexDirection: 'column',

        //         borderRadius: 8,
        //         marginLeft: 10,
        //       }}
        //     >
        //       <div style={{ backgroundColor: '#FFF', borderRadius: 8, minHeight: 340 }}>
        //         <div
        //           style={{
        //             display: 'flex',
        //             flexDirection: 'row',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //           }}
        //         >
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '70%',
        //               justifyContent: 'center',
        //               alignItems: 'center',
        //             }}
        //           >
        //             <span>
        //               <b style={{ fontSize: 19 }}>Avaliação da Expofeira</b>
        //             </span>
        //           </div>
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '30%',
        //               justifyContent: 'center',
        //               alignItems: 'center',
        //               marginTop: 25,
        //             }}
        //           >
        //             <span style={{ color: '#272859', fontSize: 25 }}>
        //               {isNaN(ratingExpofeiraMean) ? 0 : ratingExpofeiraMean} / 5
        //             </span>
        //           </div>
        //         </div>

        //         <div style={{ paddingLeft: 25, paddingRight: 25, height: '28vh' }}>
        //           <Bar data={data} options={options} />
        //         </div>
        //       </div>
        //       <div
        //         style={{ backgroundColor: '#FFF', marginTop: 10, borderRadius: 8, minHeight: 340 }}
        //       >
        //         <div
        //           style={{
        //             display: 'flex',
        //             flexDirection: 'row',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //           }}
        //         >
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '70%',
        //               justifyContent: 'center',
        //               alignItems: 'center',
        //             }}
        //           >
        //             <span>
        //               <b style={{ fontSize: 19 }}>Avaliação dos Eventos</b>
        //             </span>
        //           </div>
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '30%',
        //               justifyContent: 'center',
        //               alignItems: 'center',
        //               marginTop: 25,
        //             }}
        //           >
        //             <span style={{ color: '#272859', fontSize: 25 }}>
        //               {isNaN(ratingMean) ? 0 : ratingMean} / 5
        //             </span>
        //           </div>
        //         </div>
        //         <div
        //           className="col-sm-12"
        //           style={{
        //             paddingLeft: 25,
        //             paddingRight: 25,
        //             position: 'relative',
        //             margin: 'auto',
        //             height: '28vh',
        //             // width: '80vw',
        //           }}
        //         >
        //           <Bar data={dataEvent} options={options} />
        //         </div>
        //       </div>
        //     </div>
        //     <div
        //       className="col-sm-7"
        //       style={{
        //         display: 'flex',
        //         flexDirection: 'column',
        //         marginBottom: 5,
        //         borderRadius: 8,
        //         marginLeft: 10,
        //       }}
        //     >
        //       <div style={{ backgroundColor: '#FFF', borderRadius: 8, minHeight: 340 }}>
        //         <div
        //           style={{
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'start',
        //             alignItems: 'start',
        //           }}
        //         >
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '70%',
        //               justifyContent: 'start',
        //               alignItems: 'end',
        //             }}
        //           >
        //             <span>
        //               <b style={{ fontSize: 19, paddingLeft: 118 }}>Cadastro de Usuários</b>
        //             </span>
        //           </div>
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '30%',
        //               justifyContent: 'center',
        //               alignItems: 'center',
        //               marginTop: 10,
        //             }}
        //           >
        //             <span style={{ color: '#4F4F4F', fontSize: 16 }}>por dia</span>
        //           </div>
        //         </div>

        //         <div
        //           className="col-sm-11"
        //           style={{
        //             display: 'flex',

        //             // position: 'relative',
        //             paddingLeft: 40,
        //             height: '28vh',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //           }}
        //         >
        //           <Line
        //             style={{ justifyContent: 'center' }}
        //             data={dataLine}
        //             options={optionsLine}
        //           />
        //         </div>
        //       </div>
        //       <div style={{ backgroundColor: '#FFF', marginTop: 10, borderRadius: 8 }}>
        //         <div
        //           style={{
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'start',
        //             alignItems: 'start',
        //           }}
        //         >
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '70%',
        //               justifyContent: 'start',
        //               alignItems: 'end',
        //             }}
        //           >
        //             <span>
        //               <b style={{ fontSize: 19, paddingLeft: 100 }}>Favoritados</b>
        //             </span>
        //           </div>
        //           <div
        //             style={{
        //               display: 'flex',
        //               width: '30%',
        //               justifyContent: 'center',
        //               alignItems: 'center',
        //               marginTop: 10,
        //             }}
        //           >
        //             <span style={{ color: '#4F4F4F', fontSize: 16 }}>por evento</span>
        //           </div>
        //         </div>
        //         <div
        //           className="col-sm-11"
        //           style={{
        //             display: 'flex',

        //             // position: 'relative',
        //             paddingLeft: 40,
        //             paddingBottom: 5,
        //             height: '30vh',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //           }}
        //         >
        //           <Pie data={dataPie} options={optionsPie} />
        //         </div>
        //       </div>
        //     </div>
        //   </Container>
        // </div>
      )}
    </div>
  );
}
